// components/CustomLegend.js
import React from "react";

export default function CustomLegend({ payload, order }) {
  if (!payload) return null;

  const sortedPayload = order?.length
    ? [...payload].sort(
        (a, b) => order.indexOf(a.value) - order.indexOf(b.value)
      )
    : payload;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "10px",
        paddingBottom: "30px",
      }}
    >
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          display: "flex",
          gap: "20px", // spacing between legend items
          alignItems: "center",
          margin: -100,
        }}
      >
        {sortedPayload.map((entry, idx) => (
          <li
            key={idx}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "14px",
              fontWeight: "bold",
              color: entry.color,
            }}
          >
            {/* Colored square */}
            <span
              style={{
                display: "inline-block",
                width: "12px",
                height: "12px",
                backgroundColor: entry.color,
                borderRadius: "2px", // keep it square-ish
              }}
            ></span>
            {entry.value}
          </li>
        ))}
      </ul>
    </div>
  );
}
